import find from 'lodash/find';
import filter from 'lodash/filter';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AppContainer } from '../../components/AppContainer';
import { MerchantCard } from '../../components/MerchantCard';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { fetchCategories } from '../../store/ActionCreators';
import styles from './index.module.css';
import { SearchInput } from '../../components/SearchInput';
import { CategorySelect } from '../../components/CategorySelect';
import { LanguageSelect } from '../../components/LanguageSelect';
import { filterMerchants } from '../../store/reducers/MerchantsSlice';
import { ICategory } from '../../models/ICategory';
import { IMerchantsFilter } from '../../models/IMerchant';

export function MerchantList () {
	const dispatch = useAppDispatch();
	const { t, i18n } = useTranslation('translation');
	const allCategoriesOption: ICategory = {
		'id': 0,
		'code': 'all categories',
		'name': t('Все категории'),
		'parent_id': null
	};
	const categories = [allCategoriesOption, ...useAppSelector(state => state.categoriesReducer).categories];
	const { filteredMerchants, isLoading, error } = useAppSelector(state => state.merchantReducer);
	const { language } = useAppSelector(state => state.languageSlice);

	const initialFilter: IMerchantsFilter = {
		searchString: '',
		category: allCategoriesOption,
		categories: [],
	};

	const [merchantsFilter, setMerchantsFilter] = useState<Partial<IMerchantsFilter>>(initialFilter);

	useEffect(() => {
		i18n.changeLanguage(language);
	}, [language]);

	useEffect(() => {
		if (categories.length === 1) {
			dispatch(fetchCategories(language));
		}
		dispatch(filterMerchants(merchantsFilter));
	}, []);

	useEffect(() => {
		dispatch(fetchCategories(language));
	}, [language]);

	const handleSearch = () => {
		dispatch(filterMerchants(merchantsFilter));
	};

	const handleChange = (event: ChangeEvent & {target: HTMLInputElement}) => {
		setMerchantsFilter({ ...merchantsFilter, searchString: event.target?.value});
	};

	const handleSelect = (event: ChangeEvent & {target: HTMLSelectElement}) => {
		const selected = find(categories, c => c.id === Number(event.target.value));

		if (selected.id !== 0 && selected.code === 'all') {
			const list = filter(categories, c => c.parent_id === selected.parent_id);

			setMerchantsFilter({
				...merchantsFilter,
				categories: list,
				category: find(categories, c => c.id === Number(event.target.value))});
		} else {
			setMerchantsFilter({
				...merchantsFilter,
				categories: [],
				category: find(categories, c => c.id === Number(event.target.value))
			});
		}
	};

	useEffect(() => {
		dispatch(filterMerchants(merchantsFilter));
	}, [merchantsFilter.category, merchantsFilter.categories]);

	return (
		<AppContainer>
			<header className={styles.header}>
				<h1 className={styles.title}>{t('Покупайте онлайн')}</h1>
				<LanguageSelect value={language}/>
			</header>
			<div className={styles.search}>
				<CategorySelect
					categories={categories}
					value={merchantsFilter.category}
					onChange={handleSelect}
				/>
				<SearchInput
					value={merchantsFilter.searchString}
					handleChange={handleChange}
					handleSearch={handleSearch}
				/>
			</div>
			<div className={styles.merchant_list}>
				{isLoading && 'Loading...'}
				{error && <h4>{error}</h4>}
				{ filteredMerchants?.length > 0
					&& !isLoading
					&& filteredMerchants.map(merchant => <MerchantCard merchant={merchant} key={merchant.id}/>) }
			</div>
		</AppContainer>
	);
}
